import { TableColumn, TableConfig } from "../../../../../@shared/models/table.models";

export const FILES_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "File",
        type: "custom",
        template: "fileTemplate",
        width: "25%"
    },
    {
        field: "mimeType",
        header: "Type",
        type: "text",
        width: "10%"
    },
    {
        field: "createdBy",
        header: "Added By",
        type: "custom",
        template: "userTemplate",
        width: "15%"
    },
    {
        field: "knowledgeBases",
        header: "Knowledge Base",
        type: "custom",
        template: "knowledgeBaseTemplate",
        width: "20%"
    },
    {
        field: "numberOfTimesUsed",
        header: "No of times used",
        type: "number",
        template: "numberOfTimesUsedTemplate",
        width: "10%"
    },
    {
        field: "createdAt",
        header: "Added on",
        type: "custom",
        template: "dateTemplate",
        width: "10%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "10%"
    }
];

export const FILES_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 20],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No files found",
    globalFilter: false,
    responsive: true
}; 
